import { FC, useState } from "react";
import { getTaxes } from "../../../../network/settings";
import { useQuery } from "@tanstack/react-query";
import { Button, Modal, Select } from "antd";
import { DefaultOptionType } from "antd/es/select";
import { useIntl } from "react-intl";
import ModalAddNewTax from "../../../settings/modal/ModalAddNewTax";
import { PlusOutlined } from "@ant-design/icons";

interface TaxProps {
  tax: { id: number; name: string; tax_rate: number } | null;
  setTax: React.Dispatch<
    React.SetStateAction<{ id: number; name: string; tax_rate: number } | null>
  >;
}

const Tax: FC<TaxProps> = ({ tax, setTax }) => {
  const intl = useIntl();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { data: taxes, isLoading } = useQuery(
    ["Taxes"],
    () => getTaxes({ pagination: false }),
    {
      select: (res) => {
        if (!tax) {
          if (res?.data?.length) {
            setTax(res?.data[0]);
          } else {
            setTax({ id: 0, name: "", tax_rate: 0 });
          }
        }
        return res?.data;
      },
    }
  );
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const options: DefaultOptionType[] = Array.isArray(taxes)
    ? taxes.map((item) => ({
        value: item.id,
        label: `${item?.name} (${item?.tax_rate} %)`,
      }))
    : [];
  return (
    <div className="space-y-2 w-full">
      <Modal
        width={"50%"}
        destroyOnClose
        open={isModalOpen}
        onCancel={handleCancel}
        className="max-md:!w-[95%] max-xl:!w-[75%]"
        footer={null}
      >
        <ModalAddNewTax setTax={setTax} close={handleCancel} />
      </Modal>
      <p>{intl.formatMessage({ id: "addedTax" })}</p>
      {!isLoading ? (
        <div className="flex gap-2 items-center">
          <Select
            // allowClear
            // onClear={() => setTax(null)}
            defaultActiveFirstOption
            value={tax?.id}
            placeholder={intl.formatMessage({ id: "selectTax" })}
            onChange={(val) => {
              console.log(val);
              const existedTax = taxes?.find(
                (item: { id: number; name: string; tax_rate: number }) =>
                  item.id === val
              );
              console.log(existedTax);
              if (!existedTax) {
                return;
              }

              setTax(existedTax);
            }}
            className="w-full"
            loading={isLoading}
            options={options}
          />
          {taxes?.length < 2 ? (
            <Button
              type="link"
              htmlType="button"
              className="p-0 flex items-center justify-center w-10"
              onClick={() => {
                setIsModalOpen(true);
              }}
            >
              <PlusOutlined className="bg-[#00086D]  text-white  rounded-md p-[11px] " />
            </Button>
          ) : null}
        </div>
      ) : null}
    </div>
  );
};

export default Tax;
